'use strict';

const HistoryServiceImpl = require('services/HistoryServiceImpl'),
    Constants = require('constants/AppConstants'),
    TankStore = require('stores/TankStore'),
    Notification = require('components/Notification/Notification'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    ContentUtils = require('utils/ContentUtils');

const HistoryStore = {

    fetchHistories(success, failure) {
        HistoryServiceImpl.getHistories(function () {
            const histories = ContentUtils.parse(this.responseText);
            if (success) {
                success(histories);
            }
        }, failure);
    },

    saveChangeFields(fieldChanges, success, failure) {
        HistoryServiceImpl.saveChanges(function () {
            if (success) {
                success();
            }
        }, failure);
    },

    restore(selectedModule, history) {
        switch (selectedModule) {
            case Constants.APP_MODULE_ADMIN_TANK:
                let tankTarget = DashboardServiceCache.getTanks().find(tank => tank.id === history.id);
                tankTarget.isEnable = true;
                TankStore.changeTank(tankTarget, () => {
                    Notification.show('Tank restored');
                });
                break;
        }
    }

};

module.exports = HistoryStore;



/** WEBPACK FOOTER **
 ** ./src/stores/HistoryStore.js
 **/